import React, { useEffect, useState } from "react";
import Select from 'react-select';
const SelectComponent = (props) => {

    const [selectedOption, setSelectedOption] = useState(null);
    // Simulación de cargar un valor por defecto (por ejemplo, cuando se está editando un formulario)
    useEffect(() => {
        if (props.defaultValue) {
            const defaultOption = props.options.find(option => option.label === props.defaultValue);
            props.capOpcions(defaultOption?.value);
            setSelectedOption(defaultOption);
        }
    }, [props.defaultValue, props.options]);

    // Si el padre controla el valor (le pasa `value`), sincronizamos el estado
    // interno con ese valor. Sin esto, cuando el padre resetea su estado (por
    // ejemplo un botón "Limpiar filtros") el select seguía mostrando la
    // última opción elegida por el usuario, porque el render solo usaba
    // `selectedOption` y nunca leía `props.value`.
    useEffect(() => {
        if (props.value !== undefined) {
            setSelectedOption(props.value);
        }
    }, [props.value]);


    const handleOpcionChange = (electedOption) => {
        setSelectedOption(electedOption);
        props.capOpcions(electedOption?.value);
    };

    return (
        <div className={`${props.styleGroup}`}>
            {props.label ? <label htmlFor={props.htmlFor} className={`${props.styleLabel}`}>{props.label} </label> : null}
            <Select
                options={props.options}
                placeholder={props.customPlaceholder}
                onChange={handleOpcionChange}
                value={selectedOption}
                isDisabled={props.isDisabled}
                isClearable={props.isClearable}
            />
        </div>

    )
}

export default SelectComponent;